import { withStyles } from '@material-ui/core/styles';
import TableRow from '@material-ui/core/TableRow';

// HTML element used for cell styling to create stripped table
const StyledTableRow = withStyles(theme => ({
  root: {
    '&:nth-of-type(even)': {
      backgroundColor: '#e4e9f0',
    },
    borderStyle: 'none'
  },
}))(TableRow);
  
export default StyledTableRow;